import React from "react";
import "./CombinedReviewButtons.scss";
import {CircularProgress, Grid, IconButton, Tooltip} from "@mui/material";
import {CheckCircle, Error} from "@mui/icons-material";
import {ReviewChoice} from "../../../../services/classes/MaterializedClasses";
import {GroupedRowState} from "../../classes/GroupedRowState";
import {observer} from "mobx-react-lite";

type Props = {
    onAccept?: () => void

    /**
     * TODO CAT-2560: View only mode has no visual component
     */

    groupedRow?: GroupedRowState
}
/**
 * TODO CAT-1580: this component is not properly separating visual and control logic
 */
export const CombinedReviewButtons: React.FC<Props> = observer(({onAccept, groupedRow}) => {
    const state = groupedRow?.combinedStateVisual;
    if (!state) return <></>;
    const isAccept = state.reviewChoice === ReviewChoice.ACCEPT;
    let disableAcceptReason: string | undefined = undefined
    if (state.approvalState === 'PENDING') {
        disableAcceptReason = "Cannot accept already pending changes"
    }
    if (state.combinedCategory === 'uncategorized') {
        disableAcceptReason = "Cannot accept uncategorized changes"
    }
    if (state.approvalState === 'APPROVED') {
        disableAcceptReason = "Cannot accept already approved changes"
    }
    if (state.hasUnclassifiedSuggestions) {
        disableAcceptReason = "Cannot accept changes with unclassified suggestions";
    }

    const enabled = state.reviewEditAllowed && !state.hasUnclassifiedSuggestions;

    return <Grid container alignItems="center" justifyContent="space-evenly" className="combined-review-buttons">
        <Grid item>
            {groupedRow.combinedStateLoading
                ? <CircularProgress size={24} className="table-height"/>
                : groupedRow.combinedStateError
                    ? <Tooltip title="Something went wrong"><Error color="error"/></Tooltip>
                    : enabled
                        ? <CheckCircle
                            className={
                                'accept'
                                + (isAccept ? ' active' : ' inactive')
                                + (onAccept ? ' clickable' : '')
                            }
                            onClick={onAccept}
                        />
                        : <Tooltip title={disableAcceptReason} arrow>
                            <span>
                                <IconButton className="buttonIcon disabled" disabled>
                                    <CheckCircle className={(isAccept ? 'accept active' : '')}/>
                                </IconButton>
                            </span>
                        </Tooltip>
            }
        </Grid>
    </Grid>
});
